import React from 'react';
import { connect } from 'react-redux';

import { loadWidgetCMP } from '../actions';
import { WIDGET_JSPROP_CHANGE } from '../constants';

import _ from 'lodash';

import pickers from '../../components/pickers';

const DEBOUNCED = _.debounce(() => {
    // const { query } = browserHistory.getCurrentLocation();
    // const { pathname } = window.location;
    // const q = _.pickBy({ ...query, ...payload }, _.identity);
    // const qq = _.chain(q)
    //     .toPairs(q)
    //     .map(([key, val]) => {
    //         if (typeof val === 'object') {
    //             return [key, JSON.stringify(val)];
    //         } else {
    //             return [key, val];
    //         }
    //     })
    //     .fromPairs()
    //     .value();
    // browserHistory.replace({
    //     pathname,
    //     query: qq,
    // });
}, 300);

export const changeWidgetJSProp = payload => (dispatch, getState) => {
    dispatch({
        type: WIDGET_JSPROP_CHANGE,
        payload,
    });
    const state = getState();
    DEBOUNCED(state.editor.widgetProps);
};

const WidgetParams = connect(
    ({ editor }) => {
        const widget = editor.widget;
        return {
            widget,
        };
    },
    {
        loadWidgetCMP,
    },
)(({ widget, filter = () => true }) => {
    return (
        <div>
            {widget &&
                widget.spec.propTypes.filter(filter).map(propType => {
                    return <ConnectedPicker key={propType.key} propType={propType} />;
                })}
        </div>
    );
});

const ConnectedPicker = connect(
    ({ editor }) => ({
        jsprops: editor.jsprops,
    }),
    {
        changeWidgetJSProp,
    },
)(({ propType, jsprops, changeWidgetJSProp, ...props }) => {
    var Picker = pickers[propType.type];
    if (!Picker) return <div> {propType.type} </div>;

    return (
        <Picker
            key={propType.key}
            propKey={propType.key}
            {...propType}
            {...propType.props}
            {...jsprops}
            {...props}
            value={jsprops[propType.key]}
            onChange={(prop, val) => {
                let changedProp;
                if (typeof prop === 'object') {
                    changedProp = prop;
                } else {
                    changedProp = {};
                    changedProp[prop] = val;
                }
                changeWidgetJSProp(changedProp);
            }}
            error={false}
        />
    );
});

export { ConnectedPicker };

export default WidgetParams;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetParams.js
 **/